<template>
	<div class="pay-order-card" v-if="dataSource">
		<div class="header">
			<div class="price-row">
				<div class="unit">¥</div>
				<div class="value" v-if="!dataSource.discountFlag">{{dataSource.ticketPrice | price}}</div>
				<div class="value" v-if="dataSource.discountFlag">{{dataSource.actualPrice | price}}</div>
				<div class="origin" v-if="dataSource.discountFlag">¥{{dataSource.ticketPrice | price}}</div>
			</div>
		</div>
		<div class="time-row">
			<div class="time">
				<template v-if="dataSource.isHubBookingOrder">
					{{dataSource.hubOrderDateTimeDesc}}（预约单） 
				</template>
				<template v-else>{{dataSource.date}} {{dataSource.time}}（随时出发）</template>
			</div>
			<div class="status" :style="`color: ${dataSource.statusColor};`">
					{{ dataSource.isHubOrder ? HUB_ORDER_STATUS_MAP[dataSource.status] : dataSource.statusText }}
			</div>
		</div>
		<div class="row">
			<div class="icon on"></div>
			<div class="text">{{dataSource.onStopName}}</div>
		</div>
		<div class="row">
			<div class="icon off"></div>
			<div class="text">{{dataSource.offStopName}}</div>
		</div>
		<div class="row">
			<div class="icon count"></div>
			<div class="text">{{passengerLabel}}</div>
		</div>
		<template v-if="dataSource.ticketPriceDetail && dataSource.ticketPriceDetail.length">
			<div class="title">费用明细</div>
			<div v-for="(item,index) in dataSource.ticketPriceDetail" :key="index" class="detail-row">
				<span>{{ item.info }}</span>
				<span v-if="typeof item.discount === 'number'">{{ fenToYuan(item.discount) }}元</span>
				<span :class="{'origin-price': typeof item.discount === 'number'}">{{ fenToYuan(item.price) }}元</span>
			</div>
		</template>
		<div class="cost">订单金额：{{dataSource.actualPrice | price}}元</div>
	</div>
</template>

<script>
import { HUB_ORDER_STATUS_MAP } from '@/const/hub-status';
import { fenToYuan } from '../../../utils';

export default {
	name: 'payOrderCard',
	props: {
		dataSource: {
			type: Object
		}
	},
	filters: {
		price(price = 0) {
			return price / 100;
		}
	},
  computed: {
    passengerLabel() {
      const {singalNum, isGroupOrder } = this.dataSource || {}
      return isGroupOrder ? '专车直达' : `${singalNum}人`
    }
  },
	data() {
		return {
			HUB_ORDER_STATUS_MAP
		}
	},
	methods: {
		fenToYuan
	},
};
</script>

<style scoped lang="scss">
	.pay-order-card {
		padding: 0 14px;
		box-sizing: border-box;
		background: #fff;
		border-radius: 12px;
		margin-bottom: 50px;
		.header {
			height: 106px;
			display: flex;
			justify-content: center;
			align-items: center;
			border-bottom: 1px dashed #EEEEEE;
		}
		.price-row {
			display: flex;
			align-items: baseline;
		}
		.unit {
			font-family: DINAlternate, DINAlternate;
			font-weight: bold;
			font-size: 28px;
			color: #FE5959;
			line-height: 32px;
			text-align: left;
			font-style: normal;
		}
		.value {
			font-family: DINAlternate, DINAlternate;
			font-weight: bold;
			font-size: 60px;
			color: #FE5959;
			line-height: 70px;
			text-align: left;
			font-style: normal;
		}
		.origin {
			font-family: DINAlternate, DINAlternate;
			font-weight: bold;
			font-size: 18px;
			color: #666666;
			line-height: 21px;
			text-align: left;
			font-style: normal;
			text-decoration-line: line-through;
			margin-left: 16px;
		}
		.time-row {
			margin: 12px 0;
			display: flex;
		}
		.time {
			flex: 1;
			font-family: PingFangSC, PingFang SC;
			font-weight: bold;
			font-size: 16px;
			color: #000000;
			line-height: 22px;
			text-align: left;
			font-style: normal;
			white-space: wrap;
		}
		.status {
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 16px;
			color: #1792FF;
			line-height: 22px;
			text-align: right;
			font-style: normal;
		}
		.row {
			padding: 9px 0;
			display: flex;
		}
		.icon {
			width: 8px;
			height: 8px;
			border-radius: 50%;
			margin: 7px 8px 0 0;
		}
		.on {
			background: #04B47C;
		}
		.off {
			background: #006EFA;
		}
		.count {
			background: #FFBF00;
		}
		.text {
			flex: 1;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 16px;
			color: rgba(0,0,0,0.7);
			line-height: 22px;
			text-align: left;
			font-style: normal;
		}
		.title {
			padding: 12px 0;
			border-top: 1px dashed #EEEEEE;
			font-family: PingFangSC, PingFang SC;
			font-weight: bold;
			font-size: 16px;
			color: #000000;
			line-height: 22px;
			text-align: left;
			font-style: normal;
		}
		.detail-row {
			padding: 9px 0;
			font-family: PingFangSC, PingFang SC;
			font-weight: 400;
			font-size: 16px;
			color: rgba(0,0,0,0.7);
			line-height: 22px;
			text-align: left;
			font-style: normal;
		}
		.cost {
			padding: 12px 0;
			font-family: PingFangSC, PingFang SC;
			font-weight: bold;
			font-size: 16px;
			color: #000000;
			line-height: 22px;
			text-align: left;
			font-style: normal;
			border-top: 1px dashed #EEEEEE;
		}
		.origin-price {
			text-decoration: line-through;
		}
	}
</style>
